import { useEffect, useState } from "react";
import "./style.css";

const Header = () => {
  const [mobileView, setMobileView] = useState(false);
  const [Consult, setConsult] = useState(false);
  const [Testing, setTesting] = useState(false);
  const [Treatment, setTreatment] = useState(false);
  const [About, setAbout] = useState(false);
  const [Resources, setResources] = useState(false);

  return (
    <>
      <div className={"HeaderStyle"}>
        <a href="https://lumafertility.com/">
          <img
            src={require("../../asstes/images/logo.png")}
            className="logo-style"
          />
        </a>
        <div className="herefor-style">
          <p className="here_text">Our Services : </p>
          <a className="navlink-view " href="https://lumafertility.com/pre-conception-journey/">
            Pre-Conception Journey
          </a>
          <div style={{width: 1, height: 25, backgroundColor: '#344054',}}></div>
          <a className="navlink-view" href="https://lumafertility.com/ivf/">
            IVF
          </a>
          <div style={{width: 1, height: 25, backgroundColor: '#344054',}}></div>
          <a className="navlink-view" href="https://lumafertility.com/eggfreezing/">
            Egg Freezing
          </a>
          <div style={{width: 1, height: 25, backgroundColor: '#344054',}}></div>
          <div className="navlink-view Testingmain" style={{paddingTop: 17}}>
            <div onClick={() => {
              setTesting(!Testing)
              setConsult(false)
              setTreatment(false)
              setAbout(false)
              setResources(false)
            }} style={{ cursor: 'pointer' }}>
              Fertility Testing <img src={require('../../asstes/images/viewmore.png')} /></div>
            <div className="custome-dropdown Testingdropdown">
              <a href="https://lumafertility.com/malefertilityassessment/">  <img src={require("../../asstes/images/doctoricon.png")} /> Male Fertility Testing</a>
              <a href="https://lumafertility.com/femalefertilityassessment/"> <img src={require("../../asstes/images/embryology.png")} />  Female Fertility Testing</a>
            </div>
          </div>
          {/* <div className="navlink-view consultmain">
            <div onClick={() => {
              setConsult(!Consult)
              setTesting(false)
              setTreatment(false)
              setAbout(false)
            }
            } style={{ cursor: 'pointer' }}>Consult <img src={require('../../asstes/images/viewmore.png')} /></div>
            <div className="custome-dropdown consultdropdown">
              <a href="https://lumafertility.com/book/"> <img src={require("../../asstes/images/doctoricon.png")} /> Doctor</a>
              <a href="https://lumafertility.com/book/"><img src={require("../../asstes/images/embryology.png")} />  Embryology</a>
              <a href="https://lumafertility.com/book/"><img src={require("../../asstes/images/carespecialisticon.png")} /> Care Specialist</a>
            </div>
          </div>
          <div className="navlink-view Treatmentmain">
            <div onClick={() => {
              setTreatment(!Treatment)
              setTesting(false)
              setConsult(false)
              setAbout(false)
            }} style={{ cursor: 'pointer' }}>
              Treatment <img src={require('../../asstes/images/viewmore.png')} /></div>
            <div className="custome-dropdown Treatmentdropdown">
              <a href="https://lumafertility.com/eggfreezing/"> <img src={require("../../asstes/images/embryology.png")} />Egg Freezing</a>
              <a href="https://lumafertility.com/ivf/"> <img src={require("../../asstes/images/carespecialisticon.png")} />In Vitro Fertilisation (IVF/ICSI)</a>
              <a href="https://lumafertility.com/malefertilityassessment/"> <img src={require("../../asstes/images/malefertilityicon.png")} />  Male Fertility</a>
            </div>
          </div> */}
        </div>
        <div className="header-rightview">
          <div className="navlink-view aboutbtn">
            <div onClick={() => {
              setAbout(!About)
              setTreatment(false)
              setTesting(false)
              setConsult(false)
              setResources(false)
            }} style={{ cursor: 'pointer' }}>
              About <img src={require('../../asstes/images/viewmore.png')} /></div>
            <div className="custome-dropdown aboutshow">
              <a href="https://lumafertility.com/aboutus/"><img src={require("../../asstes/images/doctoricon.png")} /> Our Story</a>
              <a href="https://lumafertility.com/lumaexperience/"><img src={require("../../asstes/images/embryology.png")} />Luma Experience</a>
              <a href="https://lumafertility.com/aboutus/#aboutdoctor"><img src={require("../../asstes/images/doctors.png")} />Doctors</a>
              <a href="https://lumafertility.com/successandscience/"><img src={require("../../asstes/images/sucessandscience.png")} />Sucess and Science</a>
              <a href="https://lumafertility.com/lumaholistic/"><img src={require("../../asstes/images/lumaicon.png")} />Luma Holistic</a>
            </div>
          </div>
          <div className="navlink-view aboutbtn">
            <div onClick={() => {
              setAbout(false)
              setTreatment(false)
              setTesting(false)
              setConsult(false)
              setResources(!Resources)
            }} style={{ cursor: 'pointer' }}>
              Resources <img src={require('../../asstes/images/viewmore.png')} /></div>
            <div className="custome-dropdown aboutshow">
              <a href="https://lumafertility.com/blog/"><img src={require("../../asstes/images/doctoricon.png")} /> Blog</a>
              <a href="https://lumafertility-ftc.lpages.co/ttc-e-guide/"><img src={require("../../asstes/images/embryology.png")} />Eguide</a>
            </div>
          </div>
          <button className="header-appoiment-btn"><a href="https://lumafertility.com/book/" style={{ color: '#fff', textDecoration: 'none' }}>Book Appointment</a></button>
        </div>


        <div className="mobile-view">
          <button className="header-appoiment-btn">Book Appointment</button>
          {!mobileView ? (
            <img
              className="hamburger-style"
              onClick={() => {
                setMobileView(true);
                setConsult(false)
                setTesting(false)
                setTreatment(false)
                setAbout(false)
                setResources(false)
              }}
              src={require("../../asstes/images/hamburger.png")}
            />
          ) : (
            <img
              onClick={() => {
                setMobileView(false);
                setConsult(false)
                setTesting(false)
                setTreatment(false)
                setAbout(false)
                setResources(false)
              }}
              className="cross-style"
              src={require("../../asstes/images/close.png")}
            />
          )}
        </div>

      </div >
      {mobileView && (
        <div className="mobilenav-container">
          <div className="header_modal_main">
            <div className="header_modal_box">
              <ul className="header_mob_menu">
                <li>
                  <p className="here_text_mobile">Our Services : </p>
                </li>
                <li>
                  <a className="navlink-view" style={{ marginVertical: 20 }} href="https://lumafertility.com/pre-conception-journey/">
                    Pre-Conception Journey
                  </a>
                </li>
                <li>
                  <a className="navlink-view" style={{ marginVertical: 20 }} href="https://lumafertility.com/ivf/">
                    IVF
                  </a>
                </li>
                <li>
                  <a className="navlink-view" style={{ marginVertical: 20 }} href="https://lumafertility.com/eggfreezing/">
                    Egg Freezing
                  </a>
                </li>
                {/* <div className="navlink-view">
                  <div style={{ cursor: 'pointer' }} onClick={() => {
                    setConsult(!Consult)
                    setTesting(false)
                    setTreatment(false)
                    setAbout(false)
                  }}>Consult <img src={require('../../asstes/images/viewmore.png')} /></div>
                  {Consult &&
                    <div className="mobile-dropdown">
                      <a href="https://lumafertility.com/book/"> <img src={require("../../asstes/images/doctoricon.png")} /> Doctor</a>
                      <a href="https://lumafertility.com/book/"><img src={require("../../asstes/images/embryology.png")} />  Embryology</a>
                      <a href="https://lumafertility.com/book/"><img src={require("../../asstes/images/carespecialisticon.png")} /> Care Specialist</a>
                    </div>
                  }
                </div> */}
                <div className="navlink-view">
                  <div onClick={() => {
                    setTesting(!Testing)
                    setConsult(false)
                    setTreatment(false)
                    setAbout(false)
                    setResources(false)
                  }} style={{ cursor: 'pointer' }}>
                    Fertility Testing <img src={require('../../asstes/images/viewmore.png')} /></div>
                  {Testing &&
                    <div className="mobile-dropdown">
                      <a href="https://lumafertility.com/malefertilityassessment/">  <img src={require("../../asstes/images/doctoricon.png")} /> Male Fertility Testing</a>
                      <a href="https://lumafertility.com/femalefertilityassessment/"> <img src={require("../../asstes/images/embryology.png")} />  Female Fertility Testing</a>
                    </div>
                  }
                </div>
                {/* <div className="navlink-view">
                  <div onClick={() => {
                    setTreatment(!Treatment)
                    setTesting(false)
                    setConsult(false)
                    setAbout(false)
                  }} style={{ cursor: 'pointer' }}>
                    Treatment <img src={require('../../asstes/images/viewmore.png')} /></div>
                  {Treatment &&
                    <div className="mobile-dropdown Treatmentdropdown">
                      <a href="https://lumafertility.com/eggfreezing/"> <img src={require("../../asstes/images/embryology.png")} />Egg Freezing</a>
                      <a href="https://lumafertility.com/ivf/"> <img src={require("../../asstes/images/carespecialisticon.png")} />In Vitro Fertilisation (IVF/ICSI)</a>
                      <a href="https://lumafertility.com/malefertilityassessment/"> <img src={require("../../asstes/images/malefertilityicon.png")} />  Male Fertility</a>
                    </div>
                  }
                </div> */}
                {/* <li>
                  <a className="navlink-view" style={{ marginVertical: 20 }} href="https://lumafertility.com/secondopinion/">
                    Second Opinion
                  </a>
                </li> */}
                <div className="navlink-view">
                  <div onClick={() => {
                    setAbout(!About)
                    setTreatment(false)
                    setTesting(false)
                    setConsult(false)
                    setResources(false)
                  }} style={{ cursor: 'pointer' }}>
                    About <img src={require('../../asstes/images/viewmore.png')} /></div>
                  {About &&
                    <div className="mobile-dropdown">
                      <a href="https://lumafertility.com/aboutus/"><img src={require("../../asstes/images/doctoricon.png")} /> Our Story</a>
                      <a href="https://lumafertility.com/lumaexperience/"><img src={require("../../asstes/images/embryology.png")} />Luma Experience</a>
                      <a href="https://lumafertility.com/aboutus/#aboutdoctor"><img src={require("../../asstes/images/doctors.png")} />Doctors</a>
                      <a href="https://lumafertility.com/successandscience/"><img src={require("../../asstes/images/sucessandscience.png")} />Sucess and Science</a>
                      <a href="https://lumafertility.com/lumaholistic/"><img src={require("../../asstes/images/lumaicon.png")} />Luma Holistic</a>
                    </div>
                  }
                </div>
                <div className="navlink-view">
                  <div onClick={() => {
                    setAbout(false)
                    setTreatment(false)
                    setTesting(false)
                    setConsult(false)
                    setResources(!Resources)
                  }} style={{ cursor: 'pointer' }}>
                    Resources <img src={require('../../asstes/images/viewmore.png')} /></div>
                  {Resources &&
                    <div className="mobile-dropdown">
                      <a href="https://lumafertility.com/blog/"><img src={require("../../asstes/images/doctoricon.png")} /> Blog</a>
                      <a href="https://lumafertility-ftc.lpages.co/ttc-e-guide/"><img src={require("../../asstes/images/embryology.png")} />Eguide</a>
                    </div>
                  }
                </div>
              </ul>
            </div>
            {/* <ul className="header_mob_menu header_bottom_nav">
              <li>
                <div className="navlink-view aboutbtn">
                  <div onClick={() => {
                    setAbout(!About)
                    setTreatment(false)
                    setTesting(false)
                    setConsult(false)
                  }} style={{ cursor: 'pointer' }}>
                    About <img src={require('../../asstes/images/viewmore.png')} /></div>
                  <div className="mobile-dropdown aboutshow">
                    <a href="https://lumafertility.com/aboutus/"><img src={require("../../asstes/images/doctoricon.png")} /> Our Story</a>
                    <a href="https://lumafertility.com/lumaexperience/"><img src={require("../../asstes/images/embryology.png")} />Luma Experience</a>
                    <a href="https://lumafertility.com/aboutus/#aboutdoctor"><img src={require("../../asstes/images/doctors.png")} />Doctors</a>
                    <a href="https://lumafertility.com/successandscience/"><img src={require("../../asstes/images/sucessandscience.png")} />Sucess and Science</a>
                    <a href="https://lumafertility.com/lumaholistic/"><img src={require("../../asstes/images/lumaicon.png")} />Luma Holistic</a>
                  </div>
                </div>
              </li>
            </ul> */}
          </div>
        </div>
      )
      }
    </>
  );
};

export default Header;
